<script setup>
import { useI18n } from 'vue-i18n';
import messages from './messages';
const { t } = useI18n({ useScope: 'local', messages });
</script>

<template>
  <p class="text-sm text-n-slate-11 m-0 py-4" role="status">
    {{ t('empty') }}
  </p>
</template>
